import { render } from "./AddEditWebBotTemplateSettings.vue?vue&type=template&id=083237c0&scoped=true"
import script from "./AddEditWebBotTemplateSettings.vue?vue&type=script&lang=js"
export * from "./AddEditWebBotTemplateSettings.vue?vue&type=script&lang=js"

import "./AddEditWebBotTemplateSettings.vue?vue&type=style&index=0&id=083237c0&scoped=true&lang=css"
import "./AddEditWebBotTemplateSettings.vue?vue&type=style&index=1&id=083237c0&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083237c0"]])

export default __exports__